import { Sparkles, Workflow, Users, LineChart } from "lucide-react";
import { Reveal, SectionHeading } from "./Reveal";
import { useT } from "../context/ContentContext";
import { useUI } from "../lib/i18n";

const ICONS = [Sparkles, Workflow, Users, LineChart];
const SPANS = ["md:col-span-7", "md:col-span-5", "md:col-span-5", "md:col-span-7"];

export default function Services() {
  const t = useT();
  const ui = useUI();
  const services = t("services") || [];
  return (
    <section id="servizi" className="py-28 md:py-40 border-t border-white/5" data-testid="services-section">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <SectionHeading index="02" label={ui.services_label} title={t("services_title") || "Servizi"} testid="services-title" />
        <div className="mt-14 grid grid-cols-1 md:grid-cols-12 gap-6">
          {services.map((s, i) => {
            const Icon = ICONS[i % ICONS.length];
            return (
              <Reveal key={i} delay={i * 0.08} className={SPANS[i % SPANS.length]}>
                <div
                  className="group h-full bg-white/[0.03] border border-white/10 p-8 md:p-10 hover:border-[#007AFF]/60 hover:bg-white/[0.05] transition-colors"
                  data-testid={`service-card-${i}`}
                >
                  <div className="flex items-start justify-between">
                    <Icon className="w-7 h-7 text-[#007AFF]" />
                    <span className="font-mono text-xs text-zinc-600">0{i + 1}</span>
                  </div>
                  <h3 className="mt-8 font-display font-bold tracking-tight text-xl md:text-2xl group-hover:text-[#007AFF] transition-colors">
                    {s.title}
                  </h3>
                  <p className="mt-4 text-sm md:text-base text-zinc-400 leading-relaxed">{s.description}</p>
                </div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
}
